(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Locksmith can hide every product on several consecutive raw pages for a customer
  // whose tags only unlock a narrow slice of the catalog. Each such page still renders
  // a marker card (see main-collection.liquid) so pagination never breaks, but since it
  // adds ~zero visible height, the grid can go many "pages" without growing enough to
  // carry the native "load more" sentinel out of and back into the viewport - which is
  // what results-list's IntersectionObserver needs in order to fire again. Without that
  // crossing, infinite scroll can go quiet even though more, possibly visible, pages
  // remain. This nudges the same observer (via its own public API - nothing here patches
  // or reimplements its logic) while the sentinel is still on-screen and the grid keeps
  // growing, and stops itself once real content fills the viewport or pagination ends.
  document.addEventListener('DOMContentLoaded', () => {
    const POLL_MS = 400;
    const MAX_STALE_CHECKS = 15;

    for (const resultsList of document.querySelectorAll('results-list[infinite-scroll="true"]')) {
      const grid = resultsList.querySelector('[ref="grid"]');
      if (!grid) continue;

      let lastCardCount = -1;
      let staleChecks = 0;

      const timer = setInterval(() => {
        const observer = resultsList.infinityScrollObserver;
        const sentinel = resultsList.querySelector('[ref="viewMoreNext"]');
        if (!observer || !sentinel) return;

        const count = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
        if (count === lastCardCount) {
          staleChecks += 1;
          if (staleChecks > MAX_STALE_CHECKS) {
            clearInterval(timer);
            return;
          }
        } else {
          staleChecks = 0;
          lastCardCount = count;
        }

        const rect = sentinel.getBoundingClientRect();
        const inView = rect.top < window.innerHeight + 100 && rect.bottom > -100;
        if (!inView) return;

        observer.unobserve(sentinel);
        observer.observe(sentinel);
      }, POLL_MS);

      setTimeout(() => clearInterval(timer), 30000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  // Locksmith can hide every product on several consecutive raw pages for a customer
  // whose tags only unlock a narrow slice of the catalog. Each such page still renders
  // a marker card (see search-results.liquid) so pagination never breaks, but since it
  // adds ~zero visible height, the grid can go many "pages" without growing enough to
  // carry the native "load more" sentinel out of and back into the viewport - which is
  // what results-list's IntersectionObserver needs in order to fire again. Without that
  // crossing, infinite scroll can go quiet even though more, possibly visible, pages
  // remain. This nudges the same observer (via its own public API - nothing here patches
  // or reimplements its logic) while the sentinel is still on-screen and the grid keeps
  // growing, and stops itself once real content fills the viewport or pagination ends.
  document.addEventListener('DOMContentLoaded', () => {
    const POLL_MS = 400;
    const MAX_STALE_CHECKS = 15;

    for (const resultsList of document.querySelectorAll('results-list[infinite-scroll="true"]')) {
      const grid = resultsList.querySelector('[ref="grid"]');
      if (!grid) continue;

      let lastCardCount = -1;
      let staleChecks = 0;

      const timer = setInterval(() => {
        const observer = resultsList.infinityScrollObserver;
        const sentinel = resultsList.querySelector('[ref="viewMoreNext"]');
        if (!observer || !sentinel) return;

        const count = grid.querySelectorAll(':scope > [ref="cards[]"]').length;
        if (count === lastCardCount) {
          staleChecks += 1;
          if (staleChecks > MAX_STALE_CHECKS) {
            clearInterval(timer);
            return;
          }
        } else {
          staleChecks = 0;
          lastCardCount = count;
        }

        const rect = sentinel.getBoundingClientRect();
        const inView = rect.top < window.innerHeight + 100 && rect.bottom > -100;
        if (!inView) return;

        observer.unobserve(sentinel);
        observer.observe(sentinel);
      }, POLL_MS);

      setTimeout(() => clearInterval(timer), 30000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
